.headlineLg {
  font: var(--headline-lg-font);
  letter-spacing: var(--headline-lg-letter-spacing);
}

.headlineMd {
  font: var(--headline-md-font);
  letter-spacing: var(--headline-md-letter-spacing);
}

.headlineSm {
  font: var(--headline-sm-font);
  letter-spacing: var(--headline-sm-letter-spacing);
}
